export interface VarietyShow {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  description: string;
  longDescription: string;
  coverImage: string;
  year: number;
  rating: number;
  episodeCount: number;
  host: string;
  platform: string;
  tags: string[];
  views: string;
  updateDate: string;
  isHot: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '爆笑综艺', slug: 'comedy' },
  { name: '音乐选秀', slug: 'music' },
  { name: '真人秀', slug: 'reality' },
  { name: '谈话节目', slug: 'talk' },
  { name: '竞技综艺', slug: 'competition' },
  { name: '旅行综艺', slug: 'travel' },
];

export const shows: VarietyShow[] = [
  {
    id: '1',
    title: '欢乐喜剧人',
    category: '爆笑综艺',
    categorySlug: 'comedy',
    description: '国内顶尖喜剧人同台竞技，笑料百出，包袱不断，每一期都让你笑到停不下来。',
    longDescription: '《欢乐喜剧人》是一档汇聚全国顶尖喜剧人才的大型喜剧竞演节目。节目邀请众多知名喜剧演员和新生代喜剧人同台竞技，通过小品、相声、脱口秀等多种喜剧形式，为观众带来最纯粹的欢乐。每一期节目都精心编排，笑点密集，包袱不断，是闲暇时光最好的解压良药。节目开播以来收视率节节攀升，深受观众喜爱。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20variety%20show%20poster%20with%20bright%20red%20and%20gold%20colors%2C%20comedians%20on%20stage%2C%20spotlight%20effect%2C%20theatrical%20atmosphere%2C%20vibrant%20energy%2C%20clean%20modern%20design%20aesthetic%2C%20professional%20stage%20photography%2C%20warm%20lighting%2C%20entertaining%20mood&width=600&height=800&seq=show-comedy-01&orientation=portrait',
    year: 2025,
    rating: 9.2,
    episodeCount: 24,
    host: '郭德纲',
    platform: '6789影院',
    tags: ['喜剧', '竞演', '热门'],
    views: '1.2亿',
    updateDate: '2026-08-01',
    isHot: true,
  },
  {
    id: '2',
    title: '中国好声音',
    category: '音乐选秀',
    categorySlug: 'music',
    description: '殿堂级音乐选秀节目，挖掘最具潜力的华语新声音，导师阵容豪华，精彩不容错过。',
    longDescription: '《中国好声音》是华语乐坛最具影响力的音乐选秀节目。节目采用盲选模式，导师仅凭声音判断学员实力，为每一位怀揣音乐梦想的学员提供最公平的舞台。节目邀请了华语乐坛顶级歌手担任导师，通过层层选拔，最终决出年度总冠军。多年来，节目为中国乐坛输送了大量优秀音乐人才，是音乐爱好者不可错过的视听盛宴。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20singing%20talent%20show%20poster%2C%20musical%20stage%20with%20colorful%20lights%2C%20microphone%20spotlight%2C%20elegant%20dark%20background%2C%20professional%20concert%20photography%2C%20warm%20golden%20accents%2C%20clean%20modern%20design&width=600&height=800&seq=show-music-01&orientation=portrait',
    year: 2026,
    rating: 9.0,
    episodeCount: 20,
    host: '华少',
    platform: '6789影院',
    tags: ['音乐', '选秀', '经典'],
    views: '2.5亿',
    updateDate: '2026-07-28',
    isHot: true,
  },
  {
    id: '3',
    title: '奔跑吧兄弟',
    category: '真人秀',
    categorySlug: 'reality',
    description: '明星户外竞技真人秀，跑男家族带你体验最刺激的户外挑战，欢乐与感动并存。',
    longDescription: '《奔跑吧兄弟》是一档大型明星户外竞技真人秀节目。节目邀请多位知名艺人组成"跑男家族"，在各地展开趣味横生的户外挑战和游戏竞赛。节目融合了竞技、旅游、文化等多元元素，既有紧张刺激的对决，也有温暖感人的瞬间。跑男家族成员之间的化学反应和真实互动，让这档节目始终保持着超高人气和话题度。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20outdoor%20reality%20show%20poster%2C%20celebrities%20running%20in%20colorful%20sportswear%2C%20bright%20sunny%20day%2C%20energetic%20atmosphere%2C%20dynamic%20action%20pose%2C%20clean%20modern%20design%2C%20vibrant%20colors&width=600&height=800&seq=show-reality-01&orientation=portrait',
    year: 2026,
    rating: 8.8,
    episodeCount: 30,
    host: '李晨',
    platform: '6789影院',
    tags: ['户外', '竞技', '明星'],
    views: '3.1亿',
    updateDate: '2026-08-02',
    isHot: true,
  },
  {
    id: '4',
    title: '脱口秀大会',
    category: '爆笑综艺',
    categorySlug: 'comedy',
    description: '新生代脱口秀演员集结，犀利吐槽社会热点，金句频出，让你笑到腹肌酸痛。',
    longDescription: '《脱口秀大会》是当下最火爆的脱口秀竞演节目。节目汇集全国最优秀的脱口秀演员，以单人表演的形式，围绕社会热点、生活百态展开犀利幽默的吐槽。每一位演员都拥有独特的个人风格，从不同角度解读生活，金句频出，引发观众强烈共鸣。节目不仅提供了高质量的娱乐内容，也展现了当代年轻人的生活态度和价值观念。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20standup%20comedy%20show%20poster%2C%20comedian%20holding%20microphone%20on%20stage%2C%20dark%20stage%20with%20spotlight%2C%20modern%20minimalist%20design%2C%20bold%20typography%2C%20warm%20spotlight%20effect%2C%20professional%20stage%20photography&width=600&height=800&seq=show-comedy-02&orientation=portrait',
    year: 2026,
    rating: 9.5,
    episodeCount: 18,
    host: '李诞',
    platform: '6789影院',
    tags: ['脱口秀', '搞笑', '热门'],
    views: '4.8亿',
    updateDate: '2026-07-30',
    isHot: true,
  },
  {
    id: '5',
    title: '向往的生活',
    category: '真人秀',
    categorySlug: 'reality',
    description: '慢综艺代表作，回归田园享受质朴生活，明星嘉宾带你体验最真实的乡村慢时光。',
    longDescription: '《向往的生活》是一档生活服务纪实节目，以"慢生活"为主题，记录明星嘉宾在乡村田园中的日常生活。节目中，常驻嘉宾和飞行嘉宾一起种地、做饭、聊天，远离城市喧嚣，回归自然本真。节目通过质朴的镜头语言，传递出对简单生活的向往和珍视，让观众在快节奏的都市生活中找到一片心灵的栖息地。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20slow%20life%20variety%20show%20poster%2C%20countryside%20scenery%20with%20wooden%20house%2C%20warm%20sunset%20light%2C%20green%20fields%2C%20peaceful%20rural%20atmosphere%2C%20natural%20colors%2C%20clean%20modern%20design&width=600&height=800&seq=show-reality-02&orientation=portrait',
    year: 2026,
    rating: 9.1,
    episodeCount: 22,
    host: '何炅',
    platform: '6789影院',
    tags: ['慢综艺', '田园', '生活'],
    views: '2.8亿',
    updateDate: '2026-07-25',
    isHot: false,
  },
  {
    id: '6',
    title: '歌手2026',
    category: '音乐选秀',
    categorySlug: 'music',
    description: '顶级歌手巅峰对决，殿堂级音乐盛宴，每一场演出都是教科书级别的现场表演。',
    longDescription: '《歌手2026》是华语乐坛最具权威性的音乐竞演节目。节目邀请华语乐坛顶级歌手同台竞技，每一期都是一场高水准的音乐盛宴。歌手们通过精心改编和现场演绎，为经典歌曲注入全新生命力。节目以其专业的音乐制作、顶级的舞台效果和歌手们震撼的现场表演，赢得了观众和业内的一致好评，是音乐爱好者每年的必追节目。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20professional%20singing%20competition%20show%20poster%2C%20singer%20on%20grand%20stage%20with%20orchestra%2C%20dramatic%20lighting%2C%20elegant%20dark%20background%2C%20golden%20stage%20lights%2C%20premium%20production%20aesthetic%2C%20clean%20design&width=600&height=800&seq=show-music-02&orientation=portrait',
    year: 2026,
    rating: 9.3,
    episodeCount: 15,
    host: '何炅',
    platform: '6789影院',
    tags: ['音乐', '竞技', '殿堂级'],
    views: '3.5亿',
    updateDate: '2026-08-03',
    isHot: true,
  },
  {
    id: '7',
    title: '圆桌派',
    category: '谈话节目',
    categorySlug: 'talk',
    description: '文化名人对谈，深度探讨社会文化话题，有观点有态度，开启思想的盛宴。',
    longDescription: '《圆桌派》是一档高品质文化对谈节目。节目由著名媒体人窦文涛主持，每期邀请三位来自不同领域的文化名人，围绕一个社会文化话题展开深入讨论。节目不追求娱乐效果，而是通过真诚的交流和思想的碰撞，为观众提供多元的视角和深度的思考。在快餐文化盛行的当下，《圆桌派》以其独特的文化气质和思想深度，成为综艺节目中的一股清流。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20cultural%20talk%20show%20poster%2C%20four%20people%20sitting%20around%20round%20table%20discussing%2C%20warm%20study%20room%20atmosphere%2C%20bookshelves%20background%2C%20intellectual%20vibe%2C%20soft%20warm%20lighting%2C%20clean%20minimalist%20design&width=600&height=800&seq=show-talk-01&orientation=portrait',
    year: 2026,
    rating: 9.4,
    episodeCount: 36,
    host: '窦文涛',
    platform: '6789影院',
    tags: ['文化', '对谈', '深度'],
    views: '1.6亿',
    updateDate: '2026-07-20',
    isHot: false,
  },
  {
    id: '8',
    title: '这！就是街舞',
    category: '竞技综艺',
    categorySlug: 'competition',
    description: '顶尖舞者热血battle，炸裂舞台燃爆全场，感受街舞文化的无限魅力。',
    longDescription: '《这！就是街舞》是一档大型街舞竞技节目。节目汇聚来自全国乃至世界各地的顶尖舞者，通过多轮battle和团队合作，争夺年度冠军。节目不仅展现了舞者们精湛的舞蹈技艺，更传递了街舞文化中热血、坚持、尊重的精神内核。震撼的舞台效果、激烈的舞蹈对决、真实的情感流露，让每一期节目都充满看点，是舞蹈爱好者和普通观众都无法抗拒的视觉盛宴。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20street%20dance%20competition%20show%20poster%2C%20dancer%20in%20dynamic%20pose%20on%20stage%2C%20colorful%20graffiti%20background%2C%20neon%20lights%2C%20urban%20street%20culture%20aesthetic%2C%20energetic%20vibe%2C%20bold%20colors%2C%20clean%20modern%20design&width=600&height=800&seq=show-dance-01&orientation=portrait',
    year: 2026,
    rating: 9.0,
    episodeCount: 16,
    host: '廖搏',
    platform: '6789影院',
    tags: ['街舞', '竞技', '热血'],
    views: '2.2亿',
    updateDate: '2026-07-22',
    isHot: false,
  },
  {
    id: '9',
    title: '花儿与少年',
    category: '旅行综艺',
    categorySlug: 'travel',
    description: '明星结伴异国旅行，真实记录旅途中的欢笑与摩擦，带你云游世界各地美景。',
    longDescription: '《花儿与少年》是一档明星旅行真人秀节目。节目邀请多位不同年龄段的明星组成旅行团，前往世界各地展开一段奇妙的旅程。在异国他乡，嘉宾们需要自己规划行程、管理预算、解决旅途中的各种问题。节目真实记录了旅途中的美好风景、文化碰撞和人际互动，既有令人捧腹的欢乐时刻，也有温暖动人的真情流露，让观众足不出户就能感受世界各地的风土人情。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20travel%20reality%20show%20poster%2C%20group%20traveling%20in%20European%20city%2C%20sunny%20day%2C%20colorful%20buildings%20background%2C%20happy%20travel%20vibe%2C%20warm%20natural%20lighting%2C%20clean%20modern%20design%20aesthetic&width=600&height=800&seq=show-travel-01&orientation=portrait',
    year: 2026,
    rating: 8.5,
    episodeCount: 14,
    host: '井柏然',
    platform: '6789影院',
    tags: ['旅行', '真人秀', '美景'],
    views: '1.9亿',
    updateDate: '2026-07-18',
    isHot: false,
  },
  {
    id: '10',
    title: '奇葩说',
    category: '谈话节目',
    categorySlug: 'talk',
    description: '观点交锋唇枪舌剑，奇葩辩手给你不一样的角度看世界，思考从未停止。',
    longDescription: '《奇葩说》是一档说话达人秀节目，旨在寻找华人华语世界中观点独特、口才出众的"最会说话的人"。节目每期设置一个极具争议性的话题，辩手们从不同角度展开激烈的辩论交锋。节目以其开放包容的态度、犀利幽默的表达和深刻的社会洞察，引发了广泛的社会讨论。《奇葩说》不仅是一档娱乐节目，更是一个让年轻人表达自我、思考人生的平台。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20debate%20variety%20show%20poster%2C%20people%20arguing%20on%20colorful%20stage%2C%20bold%20graphic%20design%2C%20pop%20art%20style%2C%20vibrant%20neon%20colors%2C%20dynamic%20composition%2C%20modern%20creative%20design&width=600&height=800&seq=show-talk-02&orientation=portrait',
    year: 2026,
    rating: 9.1,
    episodeCount: 28,
    host: '马东',
    platform: '6789影院',
    tags: ['辩论', '观点', '脱口秀'],
    views: '2.6亿',
    updateDate: '2026-07-15',
    isHot: false,
  },
  {
    id: '11',
    title: '密室大逃脱',
    category: '竞技综艺',
    categorySlug: 'competition',
    description: '明星被困密室合力解谜逃脱，悬疑刺激烧脑不断，每一关都让人肾上腺素飙升。',
    longDescription: '《密室大逃脱》是一档实景解密体验秀。节目将明星嘉宾关入精心设计的密室中，他们需要依靠团队合作和智慧推理，在限定时间内找到线索、破解谜题、成功逃脱。节目中的密室场景制作精良，谜题设计巧妙，既有悬疑紧张的逃脱过程，也有嘉宾之间妙趣横生的互动。《密室大逃脱》以其独特的节目形式和沉浸式的观看体验，吸引了大量忠实观众。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20escape%20room%20variety%20show%20poster%2C%20mysterious%20dark%20room%20with%20clues%2C%20flashlight%20beams%2C%20suspenseful%20atmosphere%2C%20puzzle%20elements%2C%20cinematic%20lighting%2C%20thriller%20vibe%2C%20clean%20modern%20design&width=600&height=800&seq=show-escape-01&orientation=portrait',
    year: 2026,
    rating: 8.9,
    episodeCount: 20,
    host: '杨幂',
    platform: '6789影院',
    tags: ['密室', '悬疑', '解谜'],
    views: '2.0亿',
    updateDate: '2026-07-12',
    isHot: false,
  },
  {
    id: '12',
    title: '妻子的浪漫旅行',
    category: '旅行综艺',
    categorySlug: 'travel',
    description: '明星夫妻隔空对话，妻子团浪漫旅行，展现婚姻生活的甜蜜与真实。',
    longDescription: '《妻子的浪漫旅行》是一档夫妻观察治愈节目。节目以夫妻隔空对话为模式，让妻子团踏上浪漫旅程，丈夫团则留在演播室观察旅途中的妻子。节目通过旅行中的真实互动和隔空对话，展现了不同夫妻的相处模式和婚姻智慧。温馨浪漫的旅行画面、真实动人的情感流露，让这档节目成为观众了解婚姻、思考爱情的一扇窗口。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20couple%20travel%20reality%20show%20poster%2C%20women%20traveling%20in%20beautiful%20nature%2C%20romantic%20sunset%20scene%2C%20warm%20soft%20colors%2C%20elegant%20aesthetic%2C%20emotional%20atmosphere%2C%20clean%20modern%20design&width=600&height=800&seq=show-travel-02&orientation=portrait',
    year: 2026,
    rating: 8.3,
    episodeCount: 18,
    host: '谢娜',
    platform: '6789影院',
    tags: ['旅行', '情感', '夫妻'],
    views: '1.5亿',
    updateDate: '2026-07-08',
    isHot: false,
  },
  {
    id: '13',
    title: '极限挑战',
    category: '竞技综艺',
    categorySlug: 'competition',
    description: '男人帮再度集结，烧脑任务爆笑挑战，没有规则就是最大的规则。',
    longDescription: '《极限挑战》是一档大型励志体验真人秀节目。节目以"这就是命"为口号，由多位男星组成的"极限男人帮"每期接受各种出人意料的任务挑战。节目最大的特色是"没有规则"，嘉宾们可以自由发挥，常常出现令人意想不到的爆笑场面。节目不仅带给观众欢乐，也通过嘉宾们的互动传递了团结、诚信、智慧等正能量价值观。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20challenge%20variety%20show%20poster%2C%20male%20celebrities%20in%20urban%20setting%2C%20dynamic%20action%20scene%2C%20bright%20city%20background%2C%20bold%20modern%20graphic%20design%2C%20energetic%20colors%2C%20clean%20aesthetic&width=600&height=800&seq=show-challenge-01&orientation=portrait',
    year: 2026,
    rating: 8.7,
    episodeCount: 26,
    host: '黄磊',
    platform: '6789影院',
    tags: ['挑战', '搞笑', '经典'],
    views: '2.9亿',
    updateDate: '2026-07-05',
    isHot: false,
  },
  {
    id: '14',
    title: '明星大侦探',
    category: '竞技综艺',
    categorySlug: 'competition',
    description: '明星角色扮演推理探案，烧脑剧情层层反转，每一个细节都可能是关键线索。',
    longDescription: '《明星大侦探》是一档明星角色扮演推理节目。每期节目设定一个案件背景，明星嘉宾分别扮演案件中的不同角色，通过搜证、推理、投票找出真凶。节目中的案件设计精巧，剧情反转不断，嘉宾们的精彩表现和逻辑推理让人拍案叫绝。节目成功将推理游戏与综艺娱乐相结合，开创了国内推理综艺的先河，深受年轻观众喜爱。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20detective%20mystery%20variety%20show%20poster%2C%20crime%20scene%20investigation%20theme%2C%20magnifying%20glass%2C%20dark%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20dramatic%20shadows%2C%20clean%20modern%20design&width=600&height=800&seq=show-detective-01&orientation=portrait',
    year: 2026,
    rating: 9.6,
    episodeCount: 22,
    host: '何炅',
    platform: '6789影院',
    tags: ['推理', '悬疑', '烧脑'],
    views: '3.8亿',
    updateDate: '2026-08-01',
    isHot: true,
  },
  {
    id: '15',
    title: '中餐厅',
    category: '真人秀',
    categorySlug: 'reality',
    description: '明星海外经营中餐厅，用中华美食征服外国食客，展示中国饮食文化的魅力。',
    longDescription: '《中餐厅》是一档青春合伙人经营体验节目。节目邀请多位明星在海外开设一家中餐厅，从选址装修到菜品研发，从后厨烹饪到前厅服务，嘉宾们需要亲力亲为经营餐厅。节目通过真实的经营过程，展现了中华美食文化的魅力，同时也记录了嘉宾们面对困难时的团结协作和成长蜕变。《中餐厅》以其温暖治愈的风格和美食的视觉享受，收获了大批忠实观众。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20restaurant%20reality%20show%20poster%2C%20Chinese%20cuisine%20dishes%20on%20table%2C%20warm%20restaurant%20interior%2C%20steaming%20food%2C%20cozy%20atmosphere%2C%20rich%20colors%2C%20clean%20modern%20design%20aesthetic&width=600&height=800&seq=show-restaurant-01&orientation=portrait',
    year: 2026,
    rating: 8.4,
    episodeCount: 16,
    host: '黄晓明',
    platform: '6789影院',
    tags: ['美食', '经营', '文化'],
    views: '1.8亿',
    updateDate: '2026-06-28',
    isHot: false,
  },
  {
    id: '16',
    title: '王牌对王牌',
    category: '爆笑综艺',
    categorySlug: 'comedy',
    description: '经典IP重聚引发回忆杀，王牌家族爆笑对决，每期都让你开怀大笑。',
    longDescription: '《王牌对王牌》是浙江卫视推出的大型原创室内竞技真人秀节目。节目每期围绕一个主题，邀请两支王牌团队进行才艺比拼和游戏PK。节目最大的亮点是经典影视剧组的重聚，引发观众对经典的集体回忆。王牌家族的固定成员配合默契，默契的互动和精彩的表现让每一期节目都充满欢声笑语，是合家欢综艺的首选。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20game%20show%20poster%2C%20colorful%20studio%20stage%20with%20game%20elements%2C%20celebrities%20laughing%2C%20bright%20festive%20atmosphere%2C%20gold%20and%20red%20colors%2C%20professional%20stage%20photography%2C%20clean%20design&width=600&height=800&seq=show-comedy-03&orientation=portrait',
    year: 2026,
    rating: 8.9,
    episodeCount: 28,
    host: '沈腾',
    platform: '6789影院',
    tags: ['搞笑', '经典', '合家欢'],
    views: '3.3亿',
    updateDate: '2026-07-31',
    isHot: true,
  },
];

export const heroShows = shows.filter(s => s.isHot).slice(0, 4);

export function getShowsByCategory(slug: string): VarietyShow[] {
  if (slug === 'all') return shows;
  return shows.filter(s => s.categorySlug === slug);
}

export function getShowById(id: string): VarietyShow | undefined {
  return shows.find(s => s.id === id);
}

export function getRelatedShows(show: VarietyShow, count: number = 4): VarietyShow[] {
  return shows
    .filter(s => s.id !== show.id && s.categorySlug === show.categorySlug)
    .slice(0, count);
}